import Track from "../Track";
import {TTrack} from "../../types";
import {TrackListContainer} from "../SearchModule/SearchTrackResultList";
import {ErrorMessage} from "../ErrorMessage";
import {Message} from "../Message";


export type SearchedTracksListProps = {
    tracks?: Array<TTrack>,
    hasError?: boolean,
};

function SearchedTracksList(props: SearchedTracksListProps) {
    const {tracks, hasError} = props;

    return (
        <TrackListContainer>

            {!tracks && !hasError && (
                <Message>Loading...</Message>
            )}

            {(tracks?.length === 0) && (
                <Message>No songs searched so far.</Message>
            )}

            {tracks?.map(track => (
                <Track key={track.historyId} track={track}/>
            ))}
        </TrackListContainer>
    );
}

export default SearchedTracksList;